import axios from 'axios'
import util from '../util';
import constants from "../constants";


const isTestEnv = location.hostname.match('test.mhmfun.com');

const base = (util.isLocalhost() ? `https://test.mhmfun.com/lpv2`
                    : isTestEnv ? `${util.getShortDomain()}/lpv2`
                        : util.getShortDomain(true))
                    + '/api/v1';

const QRCODE_PATH = `${base}/qrcodes`;
const LANDING_PAGE_PATH = `${base}/landing-pages`;
const SHARE_LINK_PATH = `${base}/share-link`;
const DIGITAL_SIGNAGE_PATH = `${base}/digital-signage`;

const getMemberQRCodes = (memberId) => {
    return axios.get(QRCODE_PATH, {
        params: { memberId },
        headers: {
            'Authorization': 'Bearer ' + window.localStorage.getItem('tkn')
        }
    });
};

const getLocationQRCodes = (memberId, locationId) => {
    return axios.get(QRCODE_PATH, {
        params: { memberId, locationId },
        headers: {
            'Authorization': 'Bearer ' + window.localStorage.getItem('tkn')
        }
    });
};

const getQRCode = (id) => axios.get(QRCODE_PATH, { params: { id }, headers: { 'Authorization': 'Bearer ' + window.localStorage.getItem('tkn') } });

const createQRCode = (dto) => axios.post(QRCODE_PATH, dto, { headers: { 'Authorization': 'Bearer ' + window.localStorage.getItem('tkn') } });

const removeQRCode = (id) => axios.delete(`${QRCODE_PATH}/${id}`, { headers: { 'Authorization': 'Bearer ' + window.localStorage.getItem('tkn') } });

const updateQRCode = (dto) => axios.put(QRCODE_PATH, dto, { headers: { 'Authorization': 'Bearer ' + window.localStorage.getItem('tkn') } });

const updateQRCodeDesignLink = (designId) => axios.post(`${QRCODE_PATH}/design/${designId}`, null, { headers: { 'Authorization': 'Bearer ' + window.localStorage.getItem('tkn') } });

const designHasQRCode = (designId) => axios.get(`${QRCODE_PATH}/design/${designId}/has`, { headers: { 'Authorization': 'Bearer ' + window.localStorage.getItem('tkn') } });

const getMemberLandingPages = (memberId, published = true) => {
    return axios.get(LANDING_PAGE_PATH,
        {
            params: { memberId, published: published }, headers: { 'Authorization': 'Bearer ' + window.localStorage.getItem('tkn') }
        })
};

const getLocationLandingPages = (locationId) => {
    return axios.get(LANDING_PAGE_PATH, {
        params: { locationId, published: 'false' },
        headers: {
            'Authorization': 'Bearer ' + window.localStorage.getItem('tkn')
        }
    });
};

const designIsOnLP = (designId) => {
    return axios.get(`${LANDING_PAGE_PATH}/design/has`,
        {
            params: { designId }, headers: { 'Authorization': 'Bearer ' + window.localStorage.getItem('tkn') }
        })
};

const getShareLink = (designId, type = constants.SL_TYPE_SHARE_LINK) => axios.get(`${SHARE_LINK_PATH}`, { params: { designId, type }, headers: { 'Authorization': 'Bearer ' + window.localStorage.getItem('tkn') } });

const createOrUpdateShareLink = (designId, type = constants.SL_TYPE_SHARE_LINK, seo) =>
    axios.post(`${SHARE_LINK_PATH}`, null,
        {
            params: {
                designId,
                type,
                seo
            },
            headers: { 'Authorization': 'Bearer ' + window.localStorage.getItem('tkn') }
        }
    );
const createOrUpdateDigitalSignage = (designId, source) => axios.post(`${DIGITAL_SIGNAGE_PATH}`, null, { params: { designId, source }, headers: { 'Authorization': 'Bearer ' + window.localStorage.getItem('tkn') } });

const removeShareLink = (designId, type = constants.SL_TYPE_SHARE_LINK) => axios.delete(`${SHARE_LINK_PATH}/${designId}`, { params: { type }, headers: { 'Authorization': 'Bearer ' + window.localStorage.getItem('tkn') } });

export default {
    getMemberQRCodes,
    getLocationQRCodes,
    getQRCode,
    createQRCode,
    removeQRCode,
    updateQRCode,
    updateQRCodeDesignLink,
    designHasQRCode,
    getMemberLandingPages,
    getLocationLandingPages,
    designIsOnLP,
    getShareLink,
    createOrUpdateShareLink,
    removeShareLink,
    createOrUpdateDigitalSignage
}
